import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMenuVenueLogsResponse } from './types';

export const getMenuVenueLogs = async (
  menuId: string,
  venueId: string,
  logId: string,
): Promise<IMenuVenueLogsResponse> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}/venues/${venueId}/logs/${logId}`);
    if (!res.ok) {
      throw new Error('Failed to fetch menu venue logs');
    }
    const { data: menuVenueData } = await res.json();
    return menuVenueData;
  } catch (e) {
    throw new Error(e || 'Unable to fetch menu venue status');
  }
};
